import { render, staticRenderFns } from "./ActionFeedback.vue?vue&type=template&id=8b9537fc&"
import script from "./ActionFeedback.vue?vue&type=script&lang=js&"
export * from "./ActionFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports